import { IFilter } from '@root/components/ActionBar/FilterBar/FilterSelection'

/**
 * To add a single filter to the filters array used in the filter bar.
 */
export const handleAddingFilter = (
  filters: IFilter[],
  filter: IFilter,
  filterKey: string
): IFilter[] => {
  const value = filter[filterKey]

  // Remove any existing filters with the same key
  const withoutKey = filters.filter(f => !(filterKey in f))

  // If the new value is null or undefined, simply return the cleared list
  if (value === null || value === undefined) {
    return withoutKey
  }

  // If the filter already existed with this value, toggle it off
  const existed = filters.some(f => f[filterKey] === value)
  if (existed) {
    return withoutKey
  }

  // Otherwise add the new filter value
  return [...withoutKey, filter]
}

/**
 * Sets the tags in the filters array. If no tags are provided, it removes the tags filter.
 * If tags are provided, it updates the existing tags filter or adds a new one if it doesn't exist.
 */
export const setTagsInFilter = (filters: IFilter[], tagIds: number[]): IFilter[] => {
  if (tagIds.length === 0) {
    return filters.filter(f => !('tags' in f))
  }

  let updated = false

  const newFilters = filters.map(f => {
    if ('tags' in f) {
      updated = true
      return { ...f, tags: tagIds }
    }
    return f
  })

  if (!updated) {
    newFilters.push({ tags: tagIds })
  }

  return newFilters
}
